<template>
  <div
    v-if="text"
    class="cms-main-heading--wrap d-inline-block"
    :class="dense ? 'mb-4' : 'mb-10'"
  >
    <component
      :is="type || 'h2'"
      class="font-weight-medium"
      :class="[
        color,
        classByType
      ]"
    >
      {{ text }}
    </component>
  </div>
</template>

<script>
export default {
  name: 'cms-main-heading',

  props: {
    customColor: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'h2',
    },
    text: {
      type: String,
      default: '',
    },
    primary: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    color () {
      if (this.primary) {
        return 'text-primary'
      }

      return this.customColor ? `text-${this.customColor}` : ''
    },

    classByType () {
      return {
        h1: 'text-h3',
        h2: 'text-h4',
        h3: 'text-h5',
        h4: 'text-h6',
      }[this.type] || 'text-h4'
    },
  }
}
</script>
